/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars, jsx-a11y/no-static-element-interactions, no-console, no-nested-ternary, jsx-a11y/click-events-have-key-events */
import React, { useState, useCallback, useRef } from 'react';
import {
  Col,
  Row,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { ErrorMessage, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import prototypeApi from '../../../api/prototypeApi';
import FormikControl from '../../../components/common/FormikControl';
import TextError from '../../../components/common/TextError';
import SelectLists from '../../prototype/data';

const CreateMoodgen: React.FC<any> = (props: {
  history: any;
  onClose: () => void;
  toggle: () => void;
}) => {
  const { history, onClose, toggle } = props;
  const formikRef = useRef<FormikProps<any>>(null);
  const [isUpload, setIsUpload] = useState<boolean>(true);
  const [initialValues] = useState<{
    name: string | any;
    image: string | any;
    tier: string | any;
    stage: string | any;
  }>({
    name: '',
    image: '',
    tier: '',
    stage: '',
  });

  const onSubmit = async (values: any, submitProps: any) => {
    const { image, name, tier, stage } = values;
    const submitData: any = {
      name,
      image,
      tier: typeof tier === 'object' ? tier.value : tier,
      stage: typeof stage === 'object' ? stage.value : stage,
      // eslint-disable-next-line @typescript-eslint/camelcase
      prototype_status: 4,
    };

    let result;
    try {
      result = await prototypeApi.save(submitData);
    } catch (error) {
      const e = error as any;
      toast(
        typeof e.response?.data?.message === 'string'
          ? e.response?.data?.message
          : 'Sorry. Error occurred while processing request.',
        {
          type: 'error',
        },
      );
      return;
    }
    toast('Moodgen has been created successfully', {
      type: 'success',
      autoClose: 3,
    });

    submitProps.setSubmitting(false);
    submitProps.resetForm();
    history.push({
      // eslint-disable-next-line no-underscore-dangle
      pathname: `/moodgen/edit-page/${result.data.data.id}/${result.data.data.pages[0]._id}`,
      state: {
        prototypeName: name,
        pageName: result.data.data.pages[0].name,
        status: 4,
      },
    });
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Project name Required'),
    image: Yup.string().optional(),
    tier: Yup.string().optional(),
    stage: Yup.string().optional(),
  });

  return (
    <>
      <ModalHeader
        toggle={toggle}
        className="ar-edit-page__moodboard-popup-title ar-popup-close-btn"
      >
        <div className="container-fluid">
          <Row>
            <Col>Create Moodgen</Col>
          </Row>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="ar-common-form ar-common-form--fixed-max-width">
          <Formik
            innerRef={formikRef}
            enableReinitialize
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            {(formik) => {
              return (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                  }}
                >
                  <Row>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group">
                        <FormikControl
                          control="Input"
                          type="text"
                          name="name"
                          label="Project Name*"
                        />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="tier">Tier</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="tier"
                          inputId="tier"
                          options={SelectLists.tierList}
                          placeholder="tier"
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            formik.setFieldValue('tier', option);
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.tier}
                          noOptionsMessage={() => 'No options available'}
                        />
                        <ErrorMessage name="tier" component={TextError} />
                      </div>
                    </Col>
                    <Col xs="10" md="6">
                      <div className="ar-common-form__group form-group">
                        <label htmlFor="stage">Stage</label>
                        <CreatableSelect
                          className="ar-common-form__select"
                          isClearable
                          classNamePrefix="rctslct"
                          name="stage"
                          inputId="stage"
                          options={SelectLists.stageList}
                          placeholder="stage"
                          onBlur={(e) => {
                            formik.handleBlur(e);
                          }}
                          onChange={(option) => {
                            formik.setFieldValue('stage', option);
                          }}
                          backspaceRemovesValue={false}
                          value={formik.values.stage}
                          noOptionsMessage={() => 'No options available'}
                        />
                        <ErrorMessage name="stage" component={TextError} />
                      </div>
                    </Col>
                  </Row>
                </form>
              );
            }}
          </Formik>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="ar-btn ar-btn--light"
          onClick={() => formikRef.current?.handleSubmit()}
          disabled={!isUpload}
        >
          Create
        </Button>
      </ModalFooter>
    </>
  );
};

export default CreateMoodgen;
